import { ChangePasswordForm } from "@/components/auth/ChangePasswordForm";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

export default function ChangePassword() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background to-background/80 p-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-primary">MansFilms</h1>
          <p className="text-muted-foreground mt-2">Şifre Değiştirme</p>
        </div>
        <ChangePasswordForm />
      </div>
    </div>
  );
} 